import { app } from '../../app';
import { lazyLoad } from '../../lib/lazy-load';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user', {
        url: '',
        redirectTo: 'user.public.user-accounts',
        resolve: {account,prefetch,publicServicesWithSso$,publicServicesWithSsoAnd2FA$},
        views: {
            '': 'user',
            'header@user': 'userHeader',
        },
    });
}

/** @ngInject */
function account(Account) {
    return Account.get();
}

/** @ngInject */
function prefetch(publicServicesWithSso$, publicServicesWithSsoAnd2FA$) {
    publicServicesWithSso$.get();
    publicServicesWithSsoAnd2FA$.get();
}


/** @ngInject */
function publicServicesWithSso$($filter, PublicServices) {
    return lazyLoad(() => PublicServices.getAllPublicServicesThatSupportSSOFiltered())
        .map(items => {
            const custom = items.find(i => i.slug === 'other');
            custom.serviceName = 'Custom';
            return items;
        })
        .map(items => $filter('orderBy')(items, 'serviceName'))
}

/** @ngInject */
function publicServicesWithSsoAnd2FA$($filter, PublicServices) {
    return lazyLoad(() => PublicServices.getAllPublicServicesThatSupportSSOAnd2FAFiltered())
        .map(items => {
            const custom = items.find(i => i.slug === 'other');
            custom.serviceName = 'Custom';
            return items;
        })
        .map(items => $filter('orderBy')(items, 'serviceName'))
}


// WEBPACK FOOTER //
// ./src/portal/states/user/user.state.js